import styles from './SettingsToggle.module.scss'

/**
 * Pill-track switch with a circular thumb (not MUI `Switch`) for settings preference rows.
 *
 * @param {{
 *   checked?: boolean,
 *   onChange?: (next: boolean) => void,
 *   size?: 'default' | 'compact',
 *   'aria-label'?: string,
 * }} props
 */
export default function SettingsToggle({
  checked = false,
  onChange,
  size = 'default',
  'aria-label': ariaLabel,
}) {
  const compact = size === 'compact'

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      className={[
        styles.track,
        checked ? styles.trackOn : '',
        compact ? styles.trackCompact : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onChange?.(!checked)}
    >
      <span
        className={[styles.thumb, checked ? styles.thumbOn : '', compact ? styles.thumbCompact : '']
          .filter(Boolean)
          .join(' ')}
        aria-hidden
      />
    </button>
  )
}
